import moment from "moment";
import "moment/locale/pt-br";
import MomentUtils from "@date-io/moment";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import PropTypes from "prop-types";
import { lang } from "i18nLang";
import { inputTextToDate } from "utils";

moment.locale("pt-br");

interface IProps {
  [property: string]: any;

  /** Label do input. */
  label?: string;
  /** Formato da data a ser utilizado. */
  format?: string;
  /** Abrir/Fechar picker. */
  open?: boolean;
  /** Função que será chamada ao abrir o picker. */
  onOpen?: () => void;
  /** Função que será chamada ao fechar o picker. */
  onClose?: () => void;
  /** Valor do input. */
  value?: Date;
  /** Função que será chamada ao alterar o valor do campo. */
  onChange?: (date: Date, value?: string) => void;
  onBlur?: (name: string, newDate?: Date) => void;
}

/**
 * ##### Campo com picker para escolher data.
 * Para ver mais detalhes sobre suas propriedades e métodos acesse: https://web.archive.org/web/20220808222927/https://material-ui-pickers.dev/api/KeyboardDatePicker.
 *
 * > Para as converções de datas é utitlizada a biblioteca **@date-io/moment**
 * @category Components
 * */
const DatePickerField = ({
  name,
  label,
  format,
  value,
  onChange,
  onBlur,
  ...props
}: IProps) => {
  const handleChange = (dateMoment, value) => {
    const newDate = dateMoment?.toDate();
    if (onChange) onChange(newDate, value);
  };

  const handleBlur = (ev) => {
    if (onBlur) onBlur(name, inputTextToDate(ev.target.value));
  };

  const handleAccept = (dateMoment) => {
    if (onBlur) onBlur(name, dateMoment?.toDate());
  };

  return (
    <MuiPickersUtilsProvider
      libInstance={moment}
      utils={MomentUtils}
      locale={"pt-br"}
    >
      <KeyboardDatePicker
        {...props}
        name={name}
        label={label}
        format={format}
        value={value}
        invalidDateMessage={lang("exceptions.invalidDate")}
        cancelLabel={lang("cancel")}
        clearLabel={lang("clear")}
        todayLabel={lang("today")}
        onChange={handleChange}
        onBlur={handleBlur}
        onAccept={handleAccept}
        KeyboardButtonProps={{
          "aria-label": "change date",
        }}
      />
    </MuiPickersUtilsProvider>
  );
};

DatePickerField.propType = {
  label: PropTypes.string,
  format: PropTypes.string.isRequired,
  open: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  value: PropTypes.instanceOf(Date).isRequired,
  onChange: PropTypes.func,
};

DatePickerField.defaultProps = {
  format: "DD/MM/YYYY",
};

export default DatePickerField;
